import React, { useState } from 'react'
import VideoPanel from '../Components/VideoPanel'
import VideoFrame from '../Components/VideoFrame'
import Navbar from '../Components/Navbar';

const VideoPage = () => {
  const [videos, setVideos] = useState([]);

  return (
    <div>
        <Navbar/>
        <VideoFrame/>
        <VideoPanel videos={videos} setVideos={setVideos}/>
    </div>
  )
}

export default VideoPage